import { IWebsiteConstants, ITranslation, INotificationService, IUtils, IEventHandler, IIoCContainer, IWebCoreSettings, IRandomSentenceGenerator, ISidebarManagerComponent, IWebCoreSensitiveSettings } from 'web-core-src';

export interface IWebCoreIoCContainer extends IIoCContainer {
    settings: IWebCoreSettings;
    sensitiveSettings: IWebCoreSensitiveSettings;

    translation: ITranslation;
    notificationService: INotificationService;
    utils: IUtils;
    websiteConstants: IWebsiteConstants;
    eventHandler: IEventHandler;
    randomSentenceGenerator: IRandomSentenceGenerator;
    sidebarManager: ISidebarManagerComponent;
}
